// as the consent api doesn't work in staging, we set a random usci cookie for step form submissions
import uuidv4 from '../utils/guid'

const stagingPaths = [
  '/business-finance/journey',
  '/business/business-insurance/application/superscript',
]

if (
  stagingPaths.some((path) => window.location.pathname.includes(path)) &&
  window.__APP_ENV__ === 'staging'
) {
  const randomId = uuidv4()
  document.cookie = `usci=${randomId}; path=/`
}
